import React from 'react'
import axios from '~/data/http/axios'
import queryString from 'query-string'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import {
    MAILCHIMP_APP_ID,
    peekReturnToMailchimpImport,
    consumeReturnToMailchimpImport,
    markMailchimpJustConnected
} from '~/utils/mailchimpOAuth'
import { MAILCHIMP_FLOW_PATH } from '~/pages/cp/import/paths'
import MailchimpDiscoverLoading from '~/pages/cp/company/integrations/apps/mailchimp2/loading'

export default class OAuthResponse extends React.Component {
    constructor(props) {
        super(props)
        const appId = props.match && props.match.params ? props.match.params.appId : undefined
        const mailchimpImportReturn = String(appId) === String(MAILCHIMP_APP_ID) && peekReturnToMailchimpImport()
        this.state = {
            appId: undefined,
            code: undefined,
            app: undefined,
            loadedData: false,
            failed: false,
            query: {},
            mailchimpImportReturn
        }
    }

    componentDidMount() {
        const query = queryString.parse(this.props.location.search)
        var appId = this.props.match.params.appId
        var code = query.code
        const mailchimpImportReturn = String(appId) === String(MAILCHIMP_APP_ID) && peekReturnToMailchimpImport()

        this.setState({ appId: appId, code: code, query, mailchimpImportReturn }, this.getApp)
    }

    getApp() {
        if (!this.state.appId || !this.state.code) return this.setState({ failed: true })
        var appData
        var self = this
        var theData = {
            code: self.state.code,
            redirect_uri: window.location.href
        }

        for (var prop in this.state.query) {
            theData[prop] = this.state.query[prop]
        }

        axios
            .get('/application/' + this.state.appId)
            .then((_theApp) => {
                appData = _theApp.data.Application
                this.setState({
                    add: appData
                })

                return axios.post('/application/external/oAuth/connect/' + self.state.appId, theData)
            })
            .then((resp) => {
                const isMailchimpApp = String(self.state.appId) === String(MAILCHIMP_APP_ID)
                const returnToImport = consumeReturnToMailchimpImport()

                if (isMailchimpApp && returnToImport) {
                    markMailchimpJustConnected()
                    if (self.props.history && self.props.history.replace) {
                        self.props.history.replace(MAILCHIMP_FLOW_PATH)
                    } else {
                        window.location.href = MAILCHIMP_FLOW_PATH
                    }
                    return
                }
                if (appData.appConfigUri) {
                    let appConfigUri = appData.appConfigUri
                    if (appConfigUri.indexOf('[APPID]'))
                        appConfigUri = appConfigUri.replace('[APPID]', self.state.appId)
                    if (resp.data.id) appConfigUri = appConfigUri += '?id=' + resp.data.id
                    window.location.href = appConfigUri
                } else {
                    window.location.href = '/cp/company/integrations/apps/integrationnoconfig/' + self.state.appId
                }
            })
            .catch((err) => {
                consumeReturnToMailchimpImport()
                this.setState({ failed: true, mailchimpImportReturn: false })
                console.log(err)
            })
    }

    render() {
        if (this.state.failed)
            return (
                <div>
                    <WarningHolder>Failed to connect the app, please try again</WarningHolder>
                </div>
            )

        if (this.state.mailchimpImportReturn) {
            return <MailchimpDiscoverLoading variant='connect' />
        }

        return (
            <div>
                <LoadingIcons iconType='2' className='mar-b15' />
                <h4 className='text-center'>Hooking Up the app... Wait a moment</h4>
            </div>
        )
    }
}
